import apiClient, { extractData } from "./client";
import { appendApplyFields } from "../utils/recruitmentApplyOptions";

export async function getRecruitmentInboxCounts() {
  const response = await apiClient.get("/recruitment/inbox-counts");
  return extractData(response);
}

export async function listRequisitions() {
  const response = await apiClient.get("/recruitment/requisitions");
  return extractData(response);
}

export async function createRequisition(data) {
  const response = await apiClient.post("/recruitment/requisitions", data);
  return extractData(response);
}

export async function approveRequisition(id, data = {}) {
  const response = await apiClient.post(`/recruitment/requisitions/${id}/approve`, data);
  return extractData(response);
}

export async function rejectRequisition(id, data = {}) {
  const response = await apiClient.post(`/recruitment/requisitions/${id}/reject`, data);
  return extractData(response);
}

export async function cancelRequisition(id) {
  const response = await apiClient.post(`/recruitment/requisitions/${id}/cancel`);
  return extractData(response);
}

export async function listPostings(params = {}) {
  const response = await apiClient.get("/recruitment/postings", { params });
  return extractData(response);
}

export async function createPosting(data) {
  const response = await apiClient.post("/recruitment/postings", data);
  return extractData(response);
}

export async function updatePosting(id, data) {
  const response = await apiClient.patch(`/recruitment/postings/${id}`, data);
  return extractData(response);
}

export async function listCandidates() {
  const response = await apiClient.get("/recruitment/candidates");
  return extractData(response);
}

export async function createCandidate(data) {
  const response = await apiClient.post("/recruitment/candidates", data);
  return extractData(response);
}

export async function listApplications(params = {}) {
  const response = await apiClient.get("/recruitment/applications", { params });
  return extractData(response);
}

export async function createApplication(data) {
  const response = await apiClient.post("/recruitment/applications", data);
  return extractData(response);
}

export async function applyInternalJob(fields, cvFile) {
  const formData = new FormData();
  formData.append("postingId", fields.postingId);
  appendApplyFields(formData, fields);
  formData.append("cv", cvFile);

  const response = await apiClient.post("/recruitment/applications/internal", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000,
  });
  return extractData(response);
}

export async function updateApplicationStage(id, data) {
  const response = await apiClient.patch(`/recruitment/applications/${id}/stage`, data);
  return extractData(response);
}

export async function screenApplication(id) {
  const response = await apiClient.post(`/recruitment/applications/${id}/screen`);
  return extractData(response);
}

export async function hireApplication(id, data) {
  const response = await apiClient.post(`/recruitment/applications/${id}/hire`, data);
  return extractData(response);
}

export async function listInterviews() {
  const response = await apiClient.get("/recruitment/interviews");
  return extractData(response);
}

export async function createInterview(data) {
  const response = await apiClient.post("/recruitment/interviews", data);
  return extractData(response);
}

export async function submitInterviewFeedback(id, data) {
  const response = await apiClient.post(`/recruitment/interviews/${id}/feedback`, data);
  return extractData(response);
}

export async function listOffers() {
  const response = await apiClient.get("/recruitment/offers");
  return extractData(response);
}

export async function createOffer(data) {
  const response = await apiClient.post("/recruitment/offers", data);
  return extractData(response);
}

export async function approveOffer(id, data = {}) {
  const response = await apiClient.post(`/recruitment/offers/${id}/approve`, data);
  return extractData(response);
}

export async function rejectOffer(id, data = {}) {
  const response = await apiClient.post(`/recruitment/offers/${id}/reject`, data);
  return extractData(response);
}

export async function acceptOffer(id, data = {}) {
  const response = await apiClient.post(`/recruitment/offers/${id}/accept`, data);
  return extractData(response);
}

export async function declineOffer(id, data = {}) {
  const response = await apiClient.post(`/recruitment/offers/${id}/decline`, data);
  return extractData(response);
}

export async function listPublicCareers() {
  const response = await apiClient.get("/public/careers");
  return extractData(response);
}

export async function getPublicCareer(id) {
  const response = await apiClient.get(`/public/careers/${id}`);
  return extractData(response);
}

export async function applyPublicCareer(id, fields, cvFile) {
  const formData = new FormData();
  appendApplyFields(formData, fields);
  formData.append("cv", cvFile);

  const response = await apiClient.post(`/public/careers/${id}/apply`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000,
  });
  return extractData(response);
}
